// extracted by mini-css-extract-plugin
export default {"button":"new-button_button__AhpRn"};